import React,{useEffect} from 'react';
import { Helmet } from "react-helmet-async";
import Logo from "../../assets/home/logo.png"
import Facebook from "../../assets/home/facebook.png"
import Instagram from "../../assets/home/instagram.png"
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Video from "./video.mp4"
import ThreeWave from "../../assets/home/three_wave.png"
import Wave from "../../assets/home/wave.png"
import Blur from "../../assets/teach/blur.png"
import MbBlur from "../../assets/teach/mgblur.png"
import Service from "../../assets/teach/service.png"
import Service2 from "../../assets/teach/service2.png"
import Service3 from "../../assets/teach/service3.png"
import Service4 from "../../assets/teach/service4.png"
import Service5 from "../../assets/teach/service5.png"
import Service6 from "../../assets/teach/service6.png"
import Service7 from "../../assets/teach/service7.png"
import Service8 from "../../assets/teach/service8.png"
import Service10 from "../../assets/teach/service10.png"
import Service11 from "../../assets/teach/service11.png"
import Service12 from "../../assets/teach/service12.png"
import Img1 from "../../assets/teach/img.png"
import Img2 from "../../assets/teach/img2.png"
import Img3 from "../../assets/teach/img3.png"
import Drive from "../../assets/teach/drive.png"
import Bus from "../../assets/teach/bus.png"
import Arrow from "../../assets/teach/arrow.png"
import FacebookIcon from "../../assets/home/facebook-icon.png"
import InstagramIcon from "../../assets/home/instagram-icon.png"
import "./teach.css"
import Menu from "../../assets/home/menu.png"
import X from "../../assets/home/x.png"
import Sun from "../../assets/home/sun.png"
import BlackSun from "../../assets/home/sun-black.png"
import BlueSun from "../../assets/home/sun-blue.png"
import SunBg from "../../assets/home/sunbg.png"
import WhiteWave from "../../assets/home/wave-white.png"
// import component 👇
import Drawer from 'react-modern-drawer'
//import styles 👇
import 'react-modern-drawer/dist/index.css'
import Seo from "../../components/seo"
import { getTideData } from "../../utils/tide"

// 國光客運 1877 時刻表（每日班次相同），資料來源：taiwanbus.tw
const BUS_1877_TO_WUSHI = [
  "0710", "0740", "0835", "0935", "1005", "1105", "1205", "1305", "1405",
  "1505*", "1605", "1705", "1735", "1805", "1835", "1905", "2005", "2105",
]
const BUS_1877_TO_TAIPEI = [
  "0620", "0700", "0720", "0740", "0805", "0905", "1005", "1105",
  "1205*", "1305", "1405", "1505", "1605", "1705", "1805", "1905", "2005",
]
const formatBusTime = (time: string) => time.replace("*", "").replace(/(\d{2})(\d{2})/, "$1:$2")

function Home() {
  const { t, i18n } = useTranslation();
  const navigation = useNavigate();
  const [isOpen, setIsOpen] = React.useState(false)
  const [isOpenSide, setIsOpenSide] = React.useState(false)
  const [isOpenSideMb, setIsOpenSideMb] = React.useState(false)
  const [isOpenBus, setIsOpenBus] = React.useState(false)
  const [openFaq, setOpenFaq] = React.useState<number | null>(null)
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState)
  }
  const toggleDrawerSide = () => {
    setIsOpenSide((prevState) => !prevState)
  }
  const toggleDrawerSideMb = () => {
    setIsOpenSideMb((prevState) => !prevState)
  }
  const [tideData] = React.useState(() => getTideData(new Date()))
  const [weatherData, setWeatherData] = React.useState({
    airTemp: 26,
    seaTemp: 28,
    windSpeed: 5,
    windDirection: "西北",
    waveHeight: 0.5
  })
  const getWindDirection = (degrees: number) => {
    const directions = ["北", "東北", "東", "東南", "南", "西南", "西", "西北"];
    return directions[Math.round(degrees / 45) % 8];
  }
  useEffect(() => {
    window.scrollTo(0, 0);
 }, []);
  useEffect(() => {
    const fetchSeaConditions = async () => {
      try {
        const response = await fetch(
          'https://marine-api.open-meteo.com/v1/marine?latitude=24.8607&longitude=121.8367&hourly=sea_surface_temperature,wave_height&timezone=Asia%2FTaipei&forecast_days=1'
        );
        const data = await response.json();
        const times: string[] = data.hourly.time;
        const seaTemps: number[] = data.hourly.sea_surface_temperature;
        const waveHeights: number[] = data.hourly.wave_height;
        const today = times[0].slice(0, 10);
        const currentHour = (new Date().getUTCHours() + 8) % 24;
        const hourIndex = times.indexOf(`${today}T${String(currentHour).padStart(2, '0')}:00`);
        if (hourIndex >= 0) {
          setWeatherData((prev) => ({
            ...prev,
            seaTemp: Math.round(seaTemps[hourIndex]),
            waveHeight: waveHeights[hourIndex]
          }));
        }
      } catch (error) {
        // keep fallback sea temperature/wave height
      }
    };
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          'https://api.open-meteo.com/v1/forecast?latitude=24.8607&longitude=121.8367&current=temperature_2m,wind_speed_10m,wind_direction_10m&wind_speed_unit=ms&timezone=Asia%2FTaipei'
        );
        const data = await response.json();
        setWeatherData((prev) => ({
          ...prev,
          airTemp: Math.round(data.current.temperature_2m),
          windSpeed: Math.round(data.current.wind_speed_10m),
          windDirection: getWindDirection(data.current.wind_direction_10m)
        }));
      } catch (error) {
        // keep fallback air temperature/wind data
      }
    };
    fetchSeaConditions();
    fetchWeather();
  }, []);
  return (
    <div>
      <Seo title={t("seoTeachTitle")} description={t("seoTeachDescription")} path="/teach" />
      <Helmet>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "初學者需要會游泳嗎？",
              "acceptedAnswer": { "@type": "Answer", "text": "不需要精通游泳，但建議具備基本水性。教學課程教練陪同全程於腰至胸水深淺灘區域練習，現場並有巡護員於沙灘戒護，讓你安心體驗衝浪。" }
            },
            {
              "@type": "Question",
              "name": "課程有年齡或體重限制嗎？",
              "acceptedAnswer": { "@type": "Answer", "text": "建議年齡滿 15 歲以上、55 歲以下，100公斤以下。不建議孕婦或具心臟病、高血壓、癲癇、氣喘等患者參與。" }
            },
            {
              "@type": "Question",
              "name": "上課需要自備什麼裝備？",
              "acceptedAnswer": { "@type": "Answer", "text": "男生請穿著衝浪褲／沙灘褲／泳褲，女生請穿著泳衣或運動內衣。另請自備毛巾；有近視者（250度以上）請攜帶隱形眼鏡或有度數泳鏡，以及個人沐浴用品。衝浪板、防磨衣等所有裝備皆由藍洋提供，不需自備任何器材。" }
            },
            {
              "@type": "Question",
              "name": "如何預約課程？",
              "acceptedAnswer": { "@type": "Answer", "text": "可透過線上預訂系統預約，選取最適合的時段。" }
            },
            {
              "@type": "Question",
              "name": "烏石港全年都適合衝浪嗎？",
              "acceptedAnswer": { "@type": "Answer", "text": "烏石港全年皆可衝浪。夏季（4–10 月）浪況較溫和，最適合初學者體驗；冬季東北季風帶來更大的浪，適合有基礎的進階學員。" }
            },
            {
              "@type": "Question",
              "name": "天候不佳時可以上課嗎？",
              "acceptedAnswer": { "@type": "Answer", "text": "課程安排以安全為第一優先。遇到颱風、強風或危險浪況時，教練會即時評估現場狀況，視情況調整或暫停課程，並第一時間通知學員。" }
            }
          ]
        })}</script>
      </Helmet>
      <div className='teach_web'>
      <button style={{display:"flex",position:"fixed",right:24,bottom:24,width:64,height:64,border:"none",backgroundColor:"white",boxShadow:"0px 4px 24px 0px rgba(12, 11, 11, 0.12)",borderRadius:16,justifyContent:"center",alignItems:"center"}} onClick={()=>{
        setIsOpenSide(true)
      }}>
      <img src={BlackSun} style={{ width: 32, height: 32 }} alt="" />

      </button>
        <div style={{ position: "fixed", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", paddingTop: 20 }}>
          <Link to="/home" style={{ marginLeft: 50 }}>
            <img src={Logo} style={{ width: 80, height: 80 }} alt="藍洋衝浪 Blue Ocean Surf" />
          </Link>
          <div style={{ marginRight: 50, display: "flex", alignItems: "center" }}>
            <span style={{ fontWeight: "bold", fontSize: 16, marginRight: 50, fontFamily: "Noto Sans TC", color: "#0C0B0B" }}>{t("surfTeaching")}</span>
            <Link to="/contact" style={{ fontWeight: "bold", fontSize: 16, marginRight: 50, fontFamily: "Noto Sans TC", color: "#0C0B0B", textDecoration: "none" }}>{t("contact")}</Link>
            <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 50 }}>
              <img src={Facebook} style={{ width: 24, height: 24 }} alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 50 }}>
              <img src={Instagram} style={{ width: 24, height: 24 }} alt="Instagram" />
            </a>
            <button style={{ background: "none", border: "none", fontWeight: "bold", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B" }} onClick={() => {
              if (i18n.language === "tw") {
                i18n.changeLanguage("en")
              } else {
                i18n.changeLanguage("tw")
              }
            }}>中 / 英</button>
          </div>
        </div>
        <video style={{ width: "100%", position: "absolute", zIndex: -10 }} autoPlay muted loop playsInline>
          <source src={Video} type="video/mp4" />
        </video>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "100vh" }}>
          <h1 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("surfTeaching")}</h1>
          <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
          <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", width: "50%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("surfContent")}</p>
          <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginTop: 50, marginBottom: 120 }}>
            <div style={{ width: 312, boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center", marginRight: 36 }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price1Title")}</p>
              <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$600</p>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
              <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class1")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class2")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class3")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class4")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class5")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>&nbsp;</p>
              <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
                {t("more")}
              </button>
            </div>
            <div style={{ width: 312, boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center", marginRight: 36 }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price2Title")}</p>
              <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1700</p>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
              <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class1")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class2")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class3")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class4")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class5")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class6")}</p>
              <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30, color: "#0C0B0B" }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
                {t("more")}
              </button>
            </div>
            <div style={{ width: 312, boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price3Title")}</p>
              <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1050{t("up")}</p>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
              <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class1")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class2")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class3")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class4")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class5")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class6")}</p>
              <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}>
                {t("more")}
              </button>
            </div>
          </div>
        </div>
        <div style={{ backgroundImage: `url(${Blur})`, width: "100%", height: "520px", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <p style={{ fontWeight: "800", fontSize: 36, fontFamily: "Noto Sans TC", color: "white" }}>{t("slogan")}</p>
        </div>
        <div style={{ width: "100%", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <h2 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC" }}>{t("include")}</h2>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 64, width: "70%" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service1")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service2} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service2")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service3} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service3")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service4} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service4")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service5} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service5")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 120, textAlign: "center" }}>
              <img src={Service6} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service6")}</p>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 64, width: "70%" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service7} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service7")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service8} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service8")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service10} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service10")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service11} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service11")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service12} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service12")}</p>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 120 }}>
            <img src={Img1} style={{ width: 488, height: 320, marginRight: 64 }} alt={t("blueValueTitle")} />
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: 456, height: 320 }}>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("blueValue")}</p>
              <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0, marginBottom: 32 }}>{t("blueValueTitle")}</p>
              <div style={{ width: 40, height: 4, backgroundColor: "#87C0FF" }}></div>
              <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 32 }}>{t("blueValueContent")}</p>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 120 }}>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: 456, height: 320, marginRight: 64 }}>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("blueSelect")}</p>
              <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0, marginBottom: 32 }}>{t("blueSelectTitle")}</p>
              <div style={{ width: 40, height: 4, backgroundColor: "#87C0FF" }}></div>
              <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 32 }}>{t("blueSelectContent")}</p>
            </div>
            <img src={Img2} style={{ width: 488, height: 320 }} alt={t("blueSelectTitle")} />
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 120, marginBottom: 120 }}>
            <img src={Img3} style={{ width: 488, height: 320, marginRight: 64 }} alt={t("blueProvideTitle")} />
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: 456, height: 320 }}>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("blueProvide")}</p>
              <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0, marginBottom: 32 }}>{t("blueProvideTitle")}</p>
              <div style={{ width: 40, height: 4, backgroundColor: "#87C0FF" }}></div>
              <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 32 }}>{t("blueProvideContent")}</p>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: 120, paddingBottom: 120 }}>
          <h2 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC", margin: 0 }}>{t("faqTitle")}</h2>
          <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
          <div style={{ width: "60%", marginTop: 64 }}>
            {[1,2,3,4,5,6].map((i) => (
              <div key={i} style={{ borderBottom: "1px solid #D9D9D9", paddingBottom: 24, marginBottom: 24 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>{t(`faqQ${i}`)}</p>
                  <span style={{ fontSize: 24, color: "#3697FF", lineHeight: "1", marginLeft: 16, flexShrink: 0 }}>{openFaq === i ? "−" : "+"}</span>
                </div>
                {openFaq === i && (
                  i === 4 ? (
                    <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 16, lineHeight: "28px", marginBottom: 0 }}>
                      {t("faqA4Pre")}<a href="https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN" target="_blank" rel="noopener noreferrer" style={{ color: "#3697FF" }}>{t("faqA4Link")}</a>{t("faqA4Post")}
                    </p>
                  ) : (
                    <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 16, lineHeight: "28px", marginBottom: 0 }}>{t(`faqA${i}`)}</p>
                  )
                )}
              </div>
            ))}
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <h2 style={{ fontWeight: "900", fontSize: 36, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("how")}</h2>
          <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
          <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", width: "60%", lineHeight: "40px", textAlign: "center", marginTop: 40, whiteSpace: "pre-line" }}>{t("howContent")}</p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1809.8!2d121.8363613!3d24.8732567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3467f70978b56c01%3A0xbe0c457b21954236!2z6JeN5rSL6KGd5rWq5LqM5bqS!5e0!3m2!1szh-TW!2stw!4v1718800000000!5m2!1szh-TW!2stw" width="60%" height="400" style={{ border: 0, marginTop: 64, marginBottom: 64 }} loading="lazy" title='123'></iframe>
          <div style={{ display: "flex", width: "60%", justifyContent: "space-between", marginBottom: 120 }}>
            <div style={{ display: "flex", width: "50%", flexDirection: "column" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={Drive} style={{ width: 48, height: 48, marginRight: 24 }} alt="" />
                <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B" }}>{t("driving")}</p>
              </div>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road1")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road1Content")}</p>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road2")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road2Content")}</p>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road3")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road3Content")}</p>
            </div>
            <div style={{ display: "flex", width: "50%", flexDirection: "column" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={Bus} style={{ width: 48, height: 48, marginRight: 24 }} alt="" />
                <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B" }}>{t("transportation")}</p>
              </div>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("bus")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("busContent")}</p>
              <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsOpenBus(true)}>
                <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF", marginRight: 10 }}>{t("time")}</p>
                <img src={Arrow} style={{ width: 24, height: 24, marginRight: 24 }} alt="" />

              </div>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("train")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("trainContent")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("trainContent2")}</p>
              <a href="https://www.railway.gov.tw/tra-tip-web/tip/tip001/tip112/querybytime" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF", marginRight: 10 }}>{t("time")}</p>
                <img src={Arrow} style={{ width: 24, height: 24, marginRight: 24 }} alt="" />

              </a>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 64, marginBottom: 80 }}>
            <button style={{ width: 240, height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", color: "#0C0B0B", cursor: "pointer" }} onClick={() => { window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN"); }}>
              {t("bookNow")}
            </button>
          </div>
        </div>
        <div style={{ width: "100%", backgroundColor: "black", paddingTop: 64, paddingBottom: 24 }}>
          <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white", marginLeft: 112 }}>{t("blueOcean")}</p>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 112 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("open")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>07:00 - 19:00</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 112 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("storePhone")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 3 978 9233</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 112 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("bookingPhone")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 928 378 138</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 112 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("email")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>chehow_0906@hotmail.com</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 112 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("address")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("addressRoad")}</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginTop: 15, marginLeft: 112 }}>
            <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 24 }}>
              <img src={FacebookIcon} style={{ width: 20, height: 20 }} alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer">
              <img src={InstagramIcon} style={{ width: 20, height: 20 }} alt="Instagram" />
            </a>
          </div>
          <div style={{ width: "85%", height: 1, backgroundColor: "#404040", margin: "auto", marginTop: 64 }}></div>
          <p style={{ fontWeight: "600", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", textAlign: "center", marginTop: 24 }}>© 2026藍洋衝浪店Blue Ocean Surf Shop</p>
        </div>
      </div>
      <div className='teach_phone'>
        <div style={{ position: "fixed", display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
          <Link to="/home">
            <img src={Logo} style={{ width: 48, height: 48, marginTop: 24, marginLeft: 24 }} alt="藍洋衝浪 Blue Ocean Surf" />
          </Link>
          <img src={Menu} style={{ width: 24, height: 24, marginTop: 24, marginRight: 24 }} alt="" onClick={() => {
            setIsOpen(true)
          }} />
        </div>
        <video style={{ width: "100%", height: "100vh", position: "absolute", zIndex: -10, objectFit: "cover" }} autoPlay muted loop playsInline>
          <source src={Video} type="video/mp4" />
        </video>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: "100vh" }}>
          <h1 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", marginTop: 80 }}>{t("surfTeaching")}</h1>
          <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
          <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", width: "90%", lineHeight: "40px", textAlign: "center", marginTop: 40 }}>{t("surfContent")}</p>
          <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginTop: 50, marginBottom: 120, flexDirection: "column" }}>
            <div style={{ width: "75%", boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center" }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price1Title")}</p>
              <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$600</p>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
              <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class1")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class2")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class3")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class4")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price1Class5")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>&nbsp;</p>
              <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
                {t("more")}
              </button>
            </div>
            <div style={{ width: "75%", boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center", marginTop: 30 }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price2Title")}</p>
              <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1700</p>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
              <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class1")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class2")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class3")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class4")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class5")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price2Class6")}</p>
              <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30, color: "#0C0B0B" }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
                {t("more")}
              </button>
            </div>
            <div style={{ width: "75%", boxShadow: "0px 4px 16px 0px rgba(12, 11, 11, 0.08)", borderRadius: "4px", padding: "32px 24px", display: "flex", flexDirection: "column", alignItems: "center", marginTop: 30 }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("price3Title")}</p>
              <p style={{ fontWeight: "600", fontSize: 36, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>NT$1050{t("up")}</p>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", marginBottom: 35 }}>{t("perPrice")}</p>
              <img src={Wave} style={{ width: 64, height: 8, marginBottom: 30 }} alt="" />
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class1")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class2")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class3")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class4")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class5")}</p>
              <p style={{ fontWeight: "600", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("price3Class6")}</p>
              <button style={{ width: "100%", height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", marginTop: 30 }}   onClick={()=>{
            window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN");
          }}>
                {t("more")}
              </button>
            </div>
          </div>
        </div>
        <div style={{ backgroundImage: `url(${MbBlur})`, width: "100%", height: "400px", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <p style={{ fontWeight: "800", fontSize: 24, fontFamily: "Noto Sans TC", color: "white", width: "70%", lineHeight: "40px", textAlign: "center" }}>{t("slogan")}</p>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", marginTop: 80 }}>
          <h2 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC" }}>{t("include")}</h2>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 64, width: "70%", flexWrap: "wrap" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service1")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service2} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service2")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service3} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service3")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service4} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service4")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service5} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service5")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 120, textAlign: "center" }}>
              <img src={Service6} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service6")}</p>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 20, width: "70%", flexWrap: "wrap", marginBottom: 80 }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service7} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service7")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service8} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service8")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service10} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service10")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service11} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service11")}</p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", width: 100, textAlign: "center" }}>
              <img src={Service12} style={{ width: 80, height: 80 }} alt="" />
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 10 }}>{t("service12")}</p>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 120, flexDirection: "column", width: "80%" }}>
            <img src={Img1} style={{ width: "100%" }} alt={t("blueValueTitle")} />
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("blueValue")}</p>
              <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0, marginBottom: 32 }}>{t("blueValueTitle")}</p>
              <div style={{ width: 40, height: 4, backgroundColor: "#87C0FF" }}></div>
              <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 32 }}>{t("blueValueContent")}</p>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 30, flexDirection: "column", width: "80%" }}>

            <img src={Img2} style={{ width: "100%" }} alt={t("blueSelectTitle")} />
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("blueSelect")}</p>
              <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0, marginBottom: 32 }}>{t("blueSelectTitle")}</p>
              <div style={{ width: 40, height: 4, backgroundColor: "#87C0FF" }}></div>
              <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 32 }}>{t("blueSelectContent")}</p>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#F6F6F6" }}>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 30, marginBottom: 120, width: "80%", flexDirection: "column" }}>
            <img src={Img3} style={{ width: "100%" }} alt={t("blueProvideTitle")} />
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
              <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("blueProvide")}</p>
              <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0, marginBottom: 32 }}>{t("blueProvideTitle")}</p>
              <div style={{ width: 40, height: 4, backgroundColor: "#87C0FF" }}></div>
              <p style={{ fontWeight: "500", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 32 }}>{t("blueProvideContent")}</p>
            </div>
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", paddingTop: 80, paddingBottom: 80 }}>
          <h2 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", margin: 0 }}>{t("faqTitle")}</h2>
          <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
          <div style={{ width: "90%", marginTop: 48 }}>
            {[1,2,3,4,5,6].map((i) => (
              <div key={i} style={{ borderBottom: "1px solid #D9D9D9", paddingBottom: 20, marginBottom: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }} onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <p style={{ fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0, lineHeight: "24px" }}>{t(`faqQ${i}`)}</p>
                  <span style={{ fontSize: 24, color: "#3697FF", lineHeight: "1", marginLeft: 12, flexShrink: 0 }}>{openFaq === i ? "−" : "+"}</span>
                </div>
                {openFaq === i && (
                  i === 4 ? (
                    <p style={{ fontWeight: "500", fontSize: 13, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 12, lineHeight: "26px", marginBottom: 0 }}>
                      {t("faqA4Pre")}<a href="https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN" target="_blank" rel="noopener noreferrer" style={{ color: "#3697FF" }}>{t("faqA4Link")}</a>{t("faqA4Post")}
                    </p>
                  ) : (
                    <p style={{ fontWeight: "500", fontSize: 13, fontFamily: "Noto Sans TC", color: "#404040", marginTop: 12, lineHeight: "26px", marginBottom: 0 }}>{t(`faqA${i}`)}</p>
                  )
                )}
              </div>
            ))}
          </div>
        </div>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <h2 style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", marginTop: 120 }}>{t("how")}</h2>
          <img src={ThreeWave} style={{ width: 64, height: 32, marginTop: 30 }} alt="" />
          <p style={{ fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", width: "90%", lineHeight: "40px", textAlign: "center", marginTop: 40, whiteSpace: "pre-line" }}>{t("howContent")}</p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1809.8!2d121.8363613!3d24.8732567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3467f70978b56c01%3A0xbe0c457b21954236!2z6JeN5rSL6KGd5rWq5LqM5bqS!5e0!3m2!1szh-TW!2stw!4v1718800000000!5m2!1szh-TW!2stw" width="100%" height="240" style={{ border: 0, marginTop: 64, marginBottom: 64 }} loading="lazy" title='123'></iframe>
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between", marginBottom: 120, flexDirection: "column", alignItems: "center" }}>
            <div style={{ display: "flex", width: "80%", flexDirection: "column" }}>
              <div style={{ display: "flex", alignItems: "center", flexDirection: "column", justifyContent: "center" }}>
                <img src={Drive} style={{ width: 48, height: 48 }} alt="" />
                <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B" }}>{t("driving")}</p>
              </div>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road1")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road1Content")}</p>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road2")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road2Content")}</p>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road3")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("road3Content")}</p>
            </div>
            <div style={{ display: "flex", width: "80%", flexDirection: "column", marginTop: 50 }}>
              <div style={{ display: "flex", alignItems: "center", flexDirection: "column" }}>
                <img src={Bus} style={{ width: 48, height: 48 }} alt="" />
                <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B" }}>{t("transportation")}</p>
              </div>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("bus")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("busContent")}</p>
              <div style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsOpenBus(true)}>
                <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF", marginRight: 10 }}>{t("time")}</p>
                <img src={Arrow} style={{ width: 24, height: 24, marginRight: 24 }} alt="" />

              </div>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("train")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("trainContent")}</p>
              <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#404040" }}>{t("trainContent2")}</p>
              <a href="https://www.railway.gov.tw/tra-tip-web/tip/tip001/tip112/querybytime" target="_blank" rel="noopener noreferrer" style={{ display: "flex", alignItems: "center", textDecoration: "none" }}>
                <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#3697FF", marginRight: 10 }}>{t("time")}</p>
                <img src={Arrow} style={{ width: 24, height: 24, marginRight: 24 }} alt="" />

              </a>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 48, marginBottom: 64 }}>
            <button style={{ width: 240, height: "48px", border: "none", backgroundColor: "#D7EAFF", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "40px", fontWeight: "700", fontSize: 14, fontFamily: "Noto Sans TC", color: "#0C0B0B", cursor: "pointer" }} onClick={() => { window.open("https://blueoceansurf.rezio.shop/zh-TW/product/C6VDGN"); }}>
              {t("bookNow")}
            </button>
          </div>
        </div>
        <div style={{ width: "100%", backgroundColor: "black", paddingTop: 64, paddingBottom: 24 }}>
          <p style={{ fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white", marginLeft: 24 }}>{t("blueOcean")}</p>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 24 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("open")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>07:00 - 19:00</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 24 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("storePhone")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 3 978 9233</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 24 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("bookingPhone")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>+886 928 378 138</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 24 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("email")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>chehow_0906@hotmail.com</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginLeft: 24 }}>
            <p style={{ fontWeight: "500", fontSize: 14, fontFamily: "Noto Sans TC", color: "#D9D9D9", marginRight: 24 }}>{t("address")}</p>
            <p style={{ fontWeight: "600", fontSize: 16, fontFamily: "Noto Sans TC", color: "#8F8F8F" }}>{t("addressRoad")}</p>
          </div>
          <div style={{ display: "flex", alignItems: "center", marginTop: 15, marginLeft: 24 }}>
            <a href="https://www.facebook.com/BlueOceanSurfShop/" target="_blank" rel="noopener noreferrer" style={{ marginRight: 24 }}>
              <img src={FacebookIcon} style={{ width: 20, height: 20 }} alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/blueoceansurftaiwan/" target="_blank" rel="noopener noreferrer">
              <img src={InstagramIcon} style={{ width: 20, height: 20 }} alt="Instagram" />
            </a>
          </div>
          <div style={{ width: "85%", height: 1, backgroundColor: "#404040", margin: "auto", marginTop: 64 }}></div>
          <p style={{ fontWeight: "600", fontSize: 12, fontFamily: "Noto Sans TC", color: "#8F8F8F", textAlign: "center", marginTop: 24 }}>© 2026藍洋衝浪店Blue Ocean Surf Shop</p>
        </div>

      </div>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction='right'
        className='bla bla bla'
        size={"100%"}
      >
        <div style={{ backgroundColor: "#0C0B0B", height: "100vh", display: "flex",flexDirection:"column" }}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", height: 80, alignItems: "center" }}>
            <img src={Logo} style={{ width: 48, height: 48, marginLeft: 24 }} alt="藍洋衝浪 Blue Ocean Surf"  onClick={() => {
              navigation("/home")
              setIsOpen(false)

            }}/>
            <img src={X} style={{ width: 24, height: 24, marginRight: 24 }} alt="" onClick={() => {
              setIsOpen(false)
            }} />
          </div>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              navigation("/teach")
              setIsOpen(false)

            }}>
            <p style={{fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white"}}>{t("surfTeaching")}</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              navigation("/contact")
              setIsOpen(false)

            }}>
            <p style={{fontWeight: "700", fontSize: 20, fontFamily: "Noto Sans TC", color: "white",marginTop:40}}>{t("contact")}</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              window.open("https://www.facebook.com/BlueOceanSurfShop/");
              setIsOpen(false)
            }}>
          <img src={FacebookIcon} style={{ width: 24, height: 24,marginTop:40 }} alt="Facebook" />
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
             window.open("https://www.instagram.com/blueoceansurftaiwan/");
              setIsOpen(false)
            }}>
          <img src={InstagramIcon} style={{ width: 24, height: 24,marginTop:40 }} alt="Instagram" />
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}}onClick={() => {
            if (i18n.language === "tw") {
              i18n.changeLanguage("en")
            } else {
              i18n.changeLanguage("tw")
            }
              setIsOpen(false)
            }}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "white",marginTop:40}}>中 / ＥＮ</p>
          </button>
          <button style={{border:"none",backgroundColor:"transparent"}} onClick={() => {
              setIsOpen(false)
            }}>
          <img src={Sun} style={{ width: 24, height: 24,marginTop:40 }} alt=""  onClick={()=>{
            setIsOpenSideMb(true)
          }}/>
          </button>
        </div>
      </Drawer>
      <Drawer
        open={isOpenSide}
        onClose={toggleDrawerSide}
        direction='right'
        className='bla bla bla'
        size={112}
      >
        <div style={{ height: "100vh", display: "flex",flexDirection:"column",boxShadow:"-4px 0px 16px 0px rgba(12, 11, 11, 0.12);",alignItems:"center" }}>
        <img src={BlueSun} style={{ width: 32, height: 32,marginTop:40 }} alt="" />
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.airTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>大氣</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.seaTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>海水</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windSpeed}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>風速</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.waveHeight}m</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>浪高</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windDirection}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>風向</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.lowTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.lowTides[1]}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>乾潮</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.highTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.highTides[1]}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>滿潮</p>
            </div>
        <img src={X} style={{ width: 32, height: 32,marginTop:40 }} alt="" onClick={()=>{
          setIsOpenSide(false)
        }}/>

        </div>
      </Drawer>
      <Drawer
        open={isOpenSideMb}
        onClose={toggleDrawerSideMb}
        direction='right'
        className='bla bla bla'
        size={"100%"}
      >
        <div style={{ backgroundImage: `url(${SunBg})`, height: "100vh", display: "flex",flexDirection:"column", backgroundSize: "cover" ,alignItems:"center"}}>
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", height: 80, alignItems: "center" }}>
            <img src={Logo} style={{ width: 48, height: 48, marginLeft: 24 }} alt="藍洋衝浪 Blue Ocean Surf"  onClick={() => {
              navigation("/home")
              setIsOpenSideMb(false)

            }}/>
            <img src={X} style={{ width: 24, height: 24, marginRight: 24 }} alt="" onClick={() => {
              setIsOpenSideMb(false)
            }} />
          </div>
          <img src={BlueSun} style={{ width: 56, height: 56,marginTop:40 }} alt="" />
          <div style={{display:"flex",justifyContent:"space-between",width:"40%",marginTop:30}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.airTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("air")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.seaTemp}°</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("sea")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />

          <div style={{display:"flex",justifyContent:"space-between",width:"70%"}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windSpeed}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windSpeed")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.waveHeight}m</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("waveHeight")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
             <p style={{fontWeight: "700", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{weatherData.windDirection}</p>
             <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("windDirection")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />

          <div style={{display:"flex",justifyContent:"space-between",width:"40%"}}>
          <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
          <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.lowTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.lowTides[1]}</p>
            <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("lowTide")}</p>
            </div>
            <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0,marginTop:24}}>{tideData.highTides[0]}</p>
            <p style={{fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#0C0B0B",margin:0}}>{tideData.highTides[1]}</p>
            <p style={{fontWeight: "500", fontSize: 12, fontFamily: "Noto Sans TC", color: "#0C0B0B",marginTop:20}}>{t("highTide")}</p>
            </div>

          </div>
          <img src={WhiteWave} style={{ width: 64, height: 8,marginTop:20 }} alt="" />

        </div>
      </Drawer>
      <Drawer
        open={isOpenBus}
        onClose={() => setIsOpenBus(false)}
        direction='bottom'
        className='bla bla bla'
        size={"auto"}
      >
        <div style={{ padding: 24, boxSizing: "border-box", maxHeight: "80vh", overflowY: "auto" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <p style={{ fontWeight: "900", fontSize: 24, fontFamily: "Noto Sans TC", color: "#0C0B0B", margin: 0 }}>{t("busTimetableTitle")}</p>
            <img src={X} style={{ width: 24, height: 24, cursor: "pointer" }} alt="" onClick={() => setIsOpenBus(false)} />
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 40, marginTop: 24 }}>
            <div style={{ flex: 1, minWidth: 260 }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("busToWushi")}</p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {BUS_1877_TO_WUSHI.map((time) => (
                  <span key={time} style={{ fontFamily: "Noto Sans TC", fontSize: 14, color: "#404040", border: "1px solid #D9D9D9", borderRadius: 8, padding: "4px 10px" }}>
                    {formatBusTime(time)}{time.includes("*") ? "*" : ""}
                  </span>
                ))}
              </div>
            </div>
            <div style={{ flex: 1, minWidth: 260 }}>
              <p style={{ fontWeight: "700", fontSize: 16, fontFamily: "Noto Sans TC", color: "#3697FF" }}>{t("busToTaipei")}</p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                {BUS_1877_TO_TAIPEI.map((time) => (
                  <span key={time} style={{ fontFamily: "Noto Sans TC", fontSize: 14, color: "#404040", border: "1px solid #D9D9D9", borderRadius: 8, padding: "4px 10px" }}>
                    {formatBusTime(time)}{time.includes("*") ? "*" : ""}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <p style={{ fontFamily: "Noto Sans TC", fontSize: 12, color: "#8F8F8F", marginTop: 24, marginBottom: 4 }}>* {t("busWheelchair")}</p>
          <p style={{ fontFamily: "Noto Sans TC", fontSize: 12, color: "#8F8F8F", margin: 0 }}>{t("busNote")}</p>
        </div>
      </Drawer>
    </div>
  );
}

export default Home;
